module.exports = __webpack_public_path__ + "img/ok_ios_802.png";